module.exports = __webpack_public_path__ + "img/android-clear-history.0d21aa9.webp";